import { Box, Stack } from '@mui/material'
import LactationLogo from 'assets/LactationLogo'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { BaseWidget } from '../baseWidget'

export const AvgMilkYield = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (!permissions?.license_limpness || error) return null

	const yesterdayAverage = statistics?.average_milking?.yesterday_average
	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.blueBg,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<LactationLogo color={COLORS.blue} width={16} height={12} />
				</Box>
			}
			path={'/feed/milk-yield'}
			isLoading={loading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' gap='4px' alignItems='center'>
					{(yesterdayAverage || yesterdayAverage === 0) && (
						<TypographyPrimary16Bold>
							{yesterdayAverage}
						</TypographyPrimary16Bold>
					)}
					<TypographySecondary>
						{yesterdayAverage || yesterdayAverage === 0 ? 'л/гол' : '-'}
					</TypographySecondary>
				</Stack>
				<TypographyPrimary>Средний надой</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
